import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-lite",
  "use": "icon-more-lite-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-lite\"><path d=\"M512 512m-114.8928 0a114.8928 114.8928 0 1 0 229.7856 0 114.8928 114.8928 0 1 0-229.7856 0Z\" /><path d=\"M114.8928 512m-114.8928 0a114.8928 114.8928 0 1 0 229.7856 0 114.8928 114.8928 0 1 0-229.7856 0Z\" /><path d=\"M909.1072 512m-114.8928 0a114.8928 114.8928 0 1 0 229.7856 0 114.8928 114.8928 0 1 0-229.7856 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol